<template>
  <wh-popup
    v-model="myVisible"
    :ref-form="$refs.plantForm"
    :title="null"
    class="plant-popup"
    @open="open"
  >
    <van-nav-bar :title="title" left-arrow @click-left="hidePopup">
      <template v-if="formType === 'edit'" #right>
        <van-icon class="delete-plant" name="delete" @click="deletePlant(form.id)" />
      </template>
    </van-nav-bar>
    <van-form
      ref="plantForm"
      class="plant-form"
      @submit="submitForm"
    >
      <!--      移栽时显示-->
      <land-popup-select
        v-if="formType === 'transplant'"
        :company-id="currentCompanyId"
        :land-id.sync="form.landId"
        :land-name.sync="form.landName"
        :value="form.landName"
        label="移栽至"
      />
      <template v-else>
        <crop-breed-pop-select
          :rules="rules.cropBreed"
          :value="form.cropBreed"
          label="种类"
          placeholder="请选择种养种类"
          @selectCropBreed="selectCropBreed"
        />
        <van-field
          v-model="form.cropTypeName"
          :disabled="!form.cropBreed"
          :placeholder="form.cropBreed ? `${form.cropBreed}的哪个品种` : '请先选择种类'"
          label="品种"
          name="cropTypeName"
        />
      </template>
      <template v-if="form.cropBreed">
        <template v-if="!['fishery'].includes(selectedCropBreed.cropType) && formType !== 'transplant'">
          <van-field
            :label="getFormLabel('plantStandard')"
            :rules="rules.plantStandard"
            name="plantStandard"
          >
            <template #input>
              <wh-button-radio-group
                v-model="form.plantStandard"
                border-radius="4px"
                class="plant-standard"
                height="auto"
              >
                <van-radio
                  v-for="(item,key) in plantStandard"
                  :key="key"
                  :name="item.value"
                  class="plant-standard-item"
                >
                  <van-image :src="item.icon" class="icon" />
                  <div class="caption">
                    {{ item.label }}
                  </div>
                </van-radio>
              </wh-button-radio-group>
            </template>
          </van-field>
          <van-field
            :label="getFormLabel('plantMethod')"
            :rules="rules.plantMethod"
            name="plantMethod"
          >
            <template #input>
              <van-radio-group
                v-model="form.plantMethod"
                class="radio-group"
                direction="horizontal"
              >
                <van-radio v-for="(item,key) in plantMethodRadioItems" :key="key" :name="item" class="radio-group-item">
                  {{ item }}
                </van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </template>
        <wh-popup-select
          :disabled="isEdit"
          :label="getFormLabel('plantStartDate')"
          :rules="rules.plantStartDate"
          :show-picker.sync="picker.plantStartDate.show"
          :show-text="formatTime(formDataShow.plantStartDate, 'YYYY-MM-DD')"
          name="plantStartDate"
        >
          <template #select>
            <van-datetime-picker
              v-model="form.plantStartDate"
              :min-date="picker.plantStartDate.minData"
              title="选择开始时间"
              type="date"
              @cancel="picker.plantStartDate.show = false"
              @confirm="dateSelected('plantStartDate',$event)"
            />
          </template>
        </wh-popup-select>
        <wh-popup-select
          v-if="!['育苗'].includes(form.plantMethod) && !['fishery'].includes(selectedCropBreed.cropType)"
          :label="getFormLabel('pickMonth')"
          :show-picker.sync="picker.pickMonth.show"
          :show-text="formatTime(formDataShow.pickMonth, 'YYYY-MM-DD')"
          name="pickMonth"
        >
          <template #select>
            <van-datetime-picker
              v-model="form.pickMonth"
              :min-date="picker.pickMonth.minData"
              title="选择结束时间"
              type="date"
              @cancel="picker.pickMonth.show = false"
              @confirm="dateSelected('pickMonth',$event)"
            />
          </template>
        </wh-popup-select>
        <van-field
          v-if="['agri'].includes(selectedCropBreed.cropType) && form.plantMethod !== '育苗'"
          v-model.number="form.forecastOutputAcre"
          label="预计亩产"
          name="forecastOutputAcre"
          type="number"
        >
          <template #right-icon>
            <van-tag round size="medium" type="primary">
              公斤/亩
            </van-tag>
          </template>
        </van-field>
        <van-field
          v-model.number="form.plantNum"
          :label="getFormLabel('plantNum')"
          name="plantNum"
        >
          <template #right-icon>
            <van-tag round size="medium" type="primary">
              {{ selectedCropBreed.cropUnit || initFormData.cropUnit }}
            </van-tag>
          </template>
        </van-field>
        <van-row
          v-if=" ['forestry'].includes(selectedCropBreed.cropType) && !['育苗'].includes(form.plantMethod)"
          justify="space-between"
          type="flex"
        >
          <van-field
            v-model="form.plantSpacingRow"
            label="株间距"
            name="plantSpacingRow"
            type="decimal"
          >
            <template #right-icon>
              <van-tag round size="medium" type="primary">
                {{ form.plantSpacingUnit }}
              </van-tag>
            </template>
          </van-field>
        </van-row>
      </template>
    </van-form>
  </wh-popup>
</template>

<script>
import { formPopup } from '@/utils/mixins/formPopup'
import { PLANT_GAP_UNIT, PLANT_STANDARD, PLANT_TYPE_DATE } from '@/constant/common'
import WhPopupSelect from '@/components/public/WhPopupSelect/WhPopupSelect'
import { formatTime } from '@/utils/convert/convertTime'
import api from '@/api'
import LandPopupSelect from '@/views/productManage/components/PopupSelect/LandPopupSelect'
import CropBreedPopSelect from '@/views/productManage/components/PopupSelect/CropBreedPopSelect'
import WhPopup from '@/components/public/WhPopup/WhPopup'
import WhButtonRadioGroup from '@/components/public/WhButtonRadioGroup/WhButtonRadioGroup'

export default {
  name: 'PlantPopup',
  components: { WhButtonRadioGroup, WhPopup, CropBreedPopSelect, LandPopupSelect, WhPopupSelect },
  mixins: [formPopup],
  props: {
    landId: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      plantTypeData: PLANT_TYPE_DATE,
      plantStandard: PLANT_STANDARD,
      selectedCropBreed: {
        cropType: 'agri',
        cropUnit: ''
      },
      picker: {
        crop: {
          show: false
        },
        plantStartDate: {
          show: false,
          minData: new Date(2005, 0, 1) // 3年前
        },
        pickMonth: {
          show: false,
          minData: new Date(new Date().setFullYear((new Date().getFullYear() - 1))) // 1年前
        }
      },
      formDataShow: {
        plantStartDate: '',
        pickMonth: ''
      },
      form: {
        id: undefined, // 修改时独有字段
        companyId: undefined,
        landId: undefined,
        cropDiseasesId: 0,
        landName: undefined,
        cropAgriGoodsId: undefined,
        cropBreed: undefined,
        cropType: undefined,
        cropTypeName: undefined,
        cropUnit: '',
        cropPic: undefined,
        forecastOutputAcre: 0, // 预计亩产量
        plantMethod: '', // 种养方式(移栽，育苗，直播；人工喂养，无需喂养；放养，圈养，放养+圈养)
        plantNum: undefined, // 种养数量
        plantSpacingRow: undefined, // 种植间距
        plantSpacingUnit: undefined, // 种植间距单位
        plantStandard: undefined, // 种植标准(有机，普通，绿色)
        plantStartDate: '', // 种养开始时间
        pickMonth: '', // 预计采摘日期
        isClose: undefined, // 是否采摘结束 0未结束 1结束，默认未结束
        transplantGrowId: undefined // 移栽前地块id
      },
      rules: {
        cropBreed: [{ required: true, message: '请选择种养品种' }],
        plantStandard: [{ required: true, message: '请选择标准' }],
        plantMethod: [{ required: true, message: '请选择方式' }],
        plantStartDate: [{ required: true, message: '选择开始时间' }]
      },
      plantGapOptions: PLANT_GAP_UNIT.map(item => {
        return { value: item, text: item }
      }),
      extraParamsItems: {
        crop: {
          search: undefined
        }
      },
      currentCompanyId: undefined,
      plantMethodRadioItems: []
    }
  },
  computed: {
    title() {
      return this.formType === 'create' ? '新增种养品种' : '编辑种养品种'
    },
    currentPlantTypeData() {
      const cropType = this.selectedCropBreed.cropType
      if (cropType && cropType in this.plantTypeData) {
        return this.plantTypeData[cropType]
      } else {
        return {
          name: '',
          plantType: '',
          pickType: ''
        }
      }
    },
    isEdit() {
      return this.formType === 'edit'
    }
  },
  methods: {
    formatTime,
    open() {
      // console.log('this.landId = ', this.landId)
      if (this.formType === 'create') {
        this.formDataInit(this.form, {
          landId: this.landId, // landId 由路由绑定
          companyId: this.$store.getters.companyId,
          plantStartDate: new Date()
        })
        this.formDataShow.plantStartDate = this.form.plantStartDate
        this.formDataShow.pickMonth = ''
        this.currentCompanyId = this.$store.getters.userData.id
        // console.log('open this.form = ', this.form)
      } else {
        if (this.formType === 'edit') {
          this.selectedCropBreed.cropType = this.initFormData.cropType
          this.selectedCropBreed.cropUnit = this.initFormData.cropUnit
          this.formDataShow.plantStartDate = this.initFormData.plantStartDate
          this.formDataShow.pickMonth = this.initFormData.pickMonth
        }
        let initFormData = this.initFormData
        if (this.formType === 'transplant') {
          initFormData = {
            // 移栽作物要保留或重置的值
            id: undefined,
            landId: undefined,
            companyId: this.initFormData.companyId,
            cropAgriGoodsId: this.initFormData.cropAgriGoodsId,
            cropPic: this.initFormData.cropPic,
            cropBreed: this.initFormData.cropBreed,
            cropType: this.initFormData.cropType,
            cropUnit: this.initFormData.cropUnit,
            transplantGrowId: this.initFormData.landId
          }
          this.currentCompanyId = this.initFormData.companyId
        }
        this.formDataInit(this.form, initFormData)
      }
      this.form.plantSpacingUnit = 'cm'
    },
    submitForm(form) {
      let apiName = 'createControlCropBreed'
      if (this.formType === 'edit') {
        apiName = 'updateControlCropBreed'
      }
      const params = {
        ...this.form,
        plantStartDate: formatTime(this.form.plantStartDate),
        pickMonth: formatTime(this.form.pickMonth)
      }
      api[apiName](params).then(res => {
        this.$toast.success(res.msg)
        this.hidePopup()
        this.submitFormSuccess()
      })
      // console.log('this.form = ', this.form)
    },
    selectCropBreed(item) {
      const getOneImage = (picItem) => {
        if ('pic' in picItem && picItem.pic && picItem.pic.length) {
          this.image = picItem.pic
        }
        if (this.image.length > 0) {
          return this.image[0]
        } else {
          return ''
        }
      }
      this.selectedCropBreed = {
        ...item,
        cropType: item.crop_type,
        cropUnit: item.unit
      }
      this.setPlantMethodRadioItems(this.selectedCropBreed.cropType)

      if (this.plantMethodRadioItems.length && this.formType === 'create') {
        this.form.plantMethod = this.plantMethodRadioItems[0]
      }
      if (this.formType === 'create') {
        this.form.plantStandard = '普通'
      }
      this.form.cropBreed = this.selectedCropBreed.name
      this.form.cropType = this.selectedCropBreed.cropType
      this.form.cropUnit = this.selectedCropBreed.cropUnit
      this.form.cropAgriGoodsId = this.selectedCropBreed.id
      this.form.cropPic = getOneImage(item)
      this.form.cropDiseasesId = this.selectedCropBreed.type_id || 0
    },
    dateSelected(type, val) {
      this.picker[type].show = false
      this.formDataShow[type] = this.formatTime(val)
    },
    setPlantMethodRadioItems(cropType) {
      switch (cropType) {
        case 'fishery':
          this.plantMethodRadioItems = ['人工喂养', '无需喂养']
          break
        case 'animal':
          this.plantMethodRadioItems = ['放养', '圈养', '放养+圈养']
          break
        case 'agri':
        case 'forestry':
          this.plantMethodRadioItems = ['直播', '育苗', '移栽']
          break
        default:
          this.plantMethodRadioItems = []
      }
    },
    getFormLabel(type) {
      const { cropType } = this.selectedCropBreed
      const labelMap = {
        plantNum: {
          forestry: '株数',
          agri: '株数',
          animal: '养殖数量',
          fishery: '养殖数量'
        },
        pickMonth: {
          forestry: '预计采收时间',
          agri: '预计采收时间',
          animal: '预计出栏时间',
          fishery: '投苗时间'
        },
        plantStandard: {
          forestry: '种植标准',
          agri: '种植标准',
          animal: '养殖标准',
          fishery: '养殖标准'
        },
        plantMethod: {
          forestry: '种植方式',
          agri: '种植方式',
          animal: '养殖方式',
          fishery: '养殖方式'
        }
      }
      // 移栽时开始时间为移栽时间
      if (type === 'plantStartDate') {
        if (this.formType === 'transplant') {
          return '移栽时间'
        }
        switch (cropType) {
          case 'forestry':
          case 'agri':
            switch (this.form.plantMethod) {
              case '移栽':
                return '移栽时间'
              case '育苗':
                return '育苗时间'
              case '直播':
                return '播种时间'
            }
            break
          case 'animal':
            return '养殖开始时间'
          case 'fishery':
            return '投苗时间'
        }
      } else if (this.formType === 'transplant' && type === 'plantNum') {
        return '移栽株数'
      }
      if (type in labelMap) {
        if (cropType in labelMap[type]) {
          return labelMap[type][cropType]
        }
      }
      return '--'
    },
    deletePlant(id) {
      this.$dialog.confirm({
        title: `是否删除该作物？`
      })
        .then(() => {
          api.deleteControlCropBreed({
            ids: [id]
          }).then(({ msg }) => {
            this.hidePopup()
            this.$toast.success(msg)
            this.submitFormSuccess()
            this.$emit('refreshItem', 'delete') // 通知父级元素刷新作物列表
          })
        })
        .catch(() => {
          // on cancel
        })
    }
  }
}
</script>

<style lang='less' scoped>
.plant-popup {
  /deep/ .popup-title {
    margin-top: 0;
  }
  .delete-plant {
    color: red;
    font-size: 24px;
  }
}
.plant-form {
  margin-top: 10px;
}
.crop-list {
  padding: 0 20px;
  .crop-list-item {
    border-bottom: 1px solid #e8e8e8;
    padding: 5px 0;
  }
}
.plant-standard {
  .plant-standard-item {
    &[aria-checked="true"] {
      /deep/ .van-radio__label {
        border-color: @primary-color;
      }
    }
    .icon {
      width: 30px;
    }
    .caption {
      color: #000;
    }
  }
}
</style>
